// api
import { createOeiLicencesSearchClient } from "../../../api/clientFactory";
import { GetPublicLicencesListRequestDto } from "../../../api/Client";
import { call } from "../../../api/callHelper";
// me
import { IRootViewModel } from "./models/models";

export async function initialise(filter: string, updateVm: React.Dispatch<React.SetStateAction<IRootViewModel>>): Promise<void> {
    updateVm((vm) => vm.licencesLoading(filter));

    const client = createOeiLicencesSearchClient();
    const request = new GetPublicLicencesListRequestDto({ filterFullTextSearch: filter });
    const result = await call(() => client.getPublicLicencesList(request));

    updateVm((vm) => vm.licencesLoaded(result.Response, result.Error));
}
